import { STRIPE_MIN_CHARGE_CENTS } from './schemas/voucher.js';

/**
 * Beticketing cancellation insurance (P-19, decision 0025), sold by Assur Connect and run by
 * Circles Group. The rate is an event setting; the payout is the product's contractual rule:
 * 80 % of the insured amount, at most 4 000 € (Assur Connect integration kit, section 3).
 */
export const INSURANCE_PAYOUT_BPS = 8000;
export const INSURANCE_PAYOUT_CAP_CENTS = 400_000;

/** Basis points → "17" or "17,5": the rate as written in the kit's price line. */
export const rateLabel = (rateBps: number, lng: 'fr' | 'en' = 'fr'): string =>
  (rateBps / 100).toLocaleString(lng === 'en' ? 'en-GB' : 'fr-FR', { maximumFractionDigits: 2 });

/**
 * Premium of an insured basket: `rate × insured amount`, rounded to the cent. The insured
 * amount is what the formats cost after the voucher (decision 0025 D4): one insurance for the
 * whole basket, on its total.
 */
export function insurancePremiumCents(insuredCents: number, rateBps: number): number {
  return Math.round((insuredCents * rateBps) / 10_000);
}

/** Most the insurer pays back on a claim (shown in the kit's tagline). */
export function insurancePayoutCents(insuredCents: number): number {
  return Math.min(
    Math.round((insuredCents * INSURANCE_PAYOUT_BPS) / 10_000),
    INSURANCE_PAYOUT_CAP_CENTS,
  );
}

/**
 * Whether a basket can be insured: its formats must cost something after the voucher. Under
 * Stripe's minimum the formats are free (decision 0004) and there is nothing to insure.
 */
export const insurable = (insuredCents: number): boolean => insuredCents >= STRIPE_MIN_CHARGE_CENTS;
